import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';

const PendingApproval = () => {
  const { logout } = useAuth();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#0F172A] to-[#1E3A8A] px-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="w-full max-w-md"
      >
        <div className="bg-white rounded-lg shadow-2xl p-8 text-center" data-testid="pending-approval-container">
          <div className="mb-6">
            <div className="w-20 h-20 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <Clock className="w-10 h-10 text-yellow-600" />
            </div>
            <h1 className="font-oswald text-2xl font-bold text-[#1E3A8A] uppercase tracking-tight mb-2">
              Account Pending Approval
            </h1>
            <p className="text-slate-600">
              Thanks for signing up! Your account is currently under review by our admin team.
            </p>
          </div>

          <div className="bg-blue-50 border border-blue-100 rounded-md p-4 mb-6">
            <p className="text-sm text-slate-700">
              You'll receive a notification once your account is approved. This usually takes 24-48 hours.
            </p>
          </div>

          <Button
            onClick={logout}
            variant="outline"
            className="w-full"
            data-testid="logout-button"
          >
            Log Out
          </Button>
        </div>
      </motion.div>
    </div>
  );
};

export default PendingApproval;
